module.exports = __webpack_public_path__ + "img/kuntoreitti_original.393126c6.png";